import { EntranceIllustration } from '../../assets/illustrations';
import styles from './style.module.scss';
import { ReactNode } from 'react';

interface Props {
    children: ReactNode;
    fullScreenMode?: boolean;
    childWrapperClassName?: string;
    childContentClassName?: string;
};

function Entrance(props: Props) {
    const {
        children,
        fullScreenMode,
        childContentClassName,
        childWrapperClassName,
    } = props;

    return (
        <div className={styles.container}>
            <div
                className={styles.entranceBody}
                data-is-full-screen={fullScreenMode}
            >
                <div className={`${styles.child} ${childWrapperClassName || ''}`}>
                    {children}
                    {/* <div className={`${styles.child_content} ${childContentClassName || ''}`}>
                    </div> */}
                </div>
                {!fullScreenMode && <div className={styles.illustration}>
                    <EntranceIllustration />
                    <span className={styles.illustration_slogan}>
                        Headhunting AI for meritocratic organizations
                    </span>
                </div>}
            </div>
        </div>
    );
};

export default Entrance;
